"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.objectIsEmpty = exports.redirectToSocialMediaPage = exports.scrollToTop = void 0;
var scrollToTop = function () {
    window.scrollTo({
        top: 0,
        behavior: "smooth",
    });
};
exports.scrollToTop = scrollToTop;
var redirectToSocialMediaPage = function (link) {
    // 👇️ directly change the active URL to navigate
    if (link) {
        window.open(link, "_blank");
    }
};
exports.redirectToSocialMediaPage = redirectToSocialMediaPage;
var objectIsEmpty = function (obj) {
    if (Object.keys(obj).length === 0)
        return true;
    return Object.values(obj).every(function (value) { return !value; });
};
exports.objectIsEmpty = objectIsEmpty;
